import { Box, Typography, Link } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { capitalMuiTheme } from "@opengov/capital-mui-theme";
import { ApiIdentityService } from "../contexts/ApiIdentityServiceContext";
import { QueryClientProvider } from "../contexts/QueryClientProvider";
import { useZudokuTheme } from "../hooks/useZudokuTheme";
import {
  getDescriptiveTextStyle,
  getMutedTextStyle,
} from "../styling/fieldStyles";
import { ApiIdentities } from "./ApiIdentities";

/**
 * Demo component showing how to use the ApiIdentities component
 * This can be used as a standalone page or integrated into existing layouts
 */
export function ApiIdentitiesPage() {
  const { currentTheme } = useZudokuTheme();
  const mutedTextStyle = getMutedTextStyle(currentTheme);
  const descriptiveTextStyle = getDescriptiveTextStyle(currentTheme);

  return (
    <ThemeProvider theme={capitalMuiTheme}>
      <QueryClientProvider>
        <ApiIdentityService>
          <Box sx={{ p: 3, maxWidth: "1200px", margin: "0 auto" }}>
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h1"
                sx={{
                  mb: 2,
                }}
              >
                Test Console Keys
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  descriptiveTextStyle,
                }}
              >
                Manage the authentication methods available in your API Test
                Console. When you add an identity here, it's saved in local
                storage and made available in your API Test Console.
              </Typography>
            </Box>
            <ApiIdentities />

            <Box
              sx={{
                mt: 4,
                p: 3,
                backgroundColor: currentTheme.accent,
                borderRadius: 1,
              }}
            >
              <Typography variant="h4" sx={{ mb: 1 }}>
                Documentation
              </Typography>
              <Typography variant="body2" sx={mutedTextStyle}>
                For more information about API identities and authentication,
                please refer to the <Link href="/docs/using-test-console">API documentation</Link>.
              </Typography>
            </Box>
          </Box>
        </ApiIdentityService>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
